export const LanguageMap = {
    en: ["en"],
    "en-gb": ["en-GB"],
    "en-us": ["en"],
    fr: ["fr"],
    "fr-fr": ["fr"],
    de: ["de"],
    "de-de": ["de"],
    es: ["es"],
    "es-es": ["es"],
    ja: ["ja"],
    "ja-jp": ["ja"],
    ko: ["ko"],
    "ko-kr": ["ko"],
    "pt-br": ["pt"],
    "pt-pt": ["pt-PT"],
    "zh-hans": ["zh-Hans"],
    "zh-hant": ["zh-Hant"],
    "zh-cn": ["zh-Hans"],
    "zh-hk": ["zh-Hant-HK"],
    "zh-tw": ["zh-Hant"],
};
